export default "__VITE_ASSET__BZWqTqzq__"